<template>
  <header>
    <Logo />
    <Burger />
  </header>
</template>

<script>
import Logo from '@/components/ui/Logo.vue';
import Burger from '@/components/ui/Burger.vue';

export default {
  name: 'Header',

  components: {
    Logo,
    Burger,
  },
};
</script>

<style lang="scss" scoped>
header {
  position: absolute;
  width: 138px;
  height: rem(100px);
  margin: 0 auto;
  pointer-events: auto;

  @include mq($until: ipadP) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: auto;
    padding: 0 rem(50px);
    margin: 0;

    .logo {
      width: 100px;
    }
  }
}
</style>
